export default __webpack_public_path__ + "static/media/close-icon.dac3285c.svg";